import { useSyncExternalStore } from 'react';
import { createNav, HistoryLike, Nav } from './controller';

/*
 * Один контроллер на приложение. Создаёт его App (или стенд предпросмотра —
 * с пустым адресом, чтобы стопка не трогала /preview.html), остальные берут
 * готовый.
 */

let nav: Nav | null = null;

export function initNav(history: HistoryLike, pathname: string | null, search = ''): Nav {
  if (nav) return nav;
  const n = createNav(history, pathname, search);
  window.addEventListener('popstate', () => n.onPopState());
  nav = n;
  return n;
}

export function appNav(): Nav {
  if (!nav) throw new Error('стопка экранов ещё не создана: initNav зовёт App');
  return nav;
}

/** Контроллер с подпиской: компонент перерисуется при любом изменении стопки. */
export function useNav(): Nav {
  const n = appNav();
  useSyncExternalStore(n.subscribe, () => n.version, () => n.version);
  return n;
}
